import { push } from 'connected-react-router'
import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getSelected = state => state.UserOrgSiteReducer.selected;

function* sendVendorAuditAffiliateSaga({ payload }) {
    try {
        if ((payload.items.length || 0) < 1) {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: "Please, select one or more affiliates",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            const selected = yield select(getSelected);
            const apiResponse = yield call(actionApiCall, {
                actionType: ActionTypeConstants.SEND_VENDOR_AUDIT_AFFILIATE,
                data: {
                    organization: selected.org,
                    items: payload.items
                }
            });
            if (apiResponse.res.data.response === 200) {
                yield put({ type: ActionTypeConstants.LOAD_AFFILIATES });
                yield put(push('/achieve/affiliates'));
                yield put({
                    type: ActionTypeConstants.SHOW_ALERT,
                    payload: {
                        message: apiResponse.res.message || "Successfully sent vendor audit to affiliate",
                        color: "success"
                    }
                });
                yield delay(10000)
                yield put({ type: ActionTypeConstants.HIDE_ALERT });
            } else {
                yield put({
                    type: ActionTypeConstants.SHOW_ALERT,
                    payload: {
                        message: apiResponse.res.message || "We ran into an issue while sending vendor audit to affiliate",
                        color: "danger"
                    }
                });
                yield delay(10000);
                yield put({ type: ActionTypeConstants.HIDE_ALERT });
            }
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "We ran into an issue while sending vendor audit to affiliate",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.SEND_VENDOR_AUDIT_AFFILIATE, sendVendorAuditAffiliateSaga);
}
